module.exports = __webpack_public_path__ + "img/icon94.ab3288ee.png";